// Salg (en).
window.PlummeI18n.register('en', {
  'adv.sales.productsShowMore': 'Show more',
  'adv.sales.productsNote': 'Highest revenue shows invoiced sales per product in the selected year. Growth and decline show the percentage change in revenue from the same product last year. Products without comparable prior-year figures are excluded from growth and decline.',
  'adv.sales.productsPage': 'Page {page} of {pages}',
  'adv.sales.productsPrevious': 'Previous page for {label}',
  'adv.sales.productsNext': 'Next page for {label}',
  'adv.sales.scn.adjust.priceUp': 'Price increase',
  'adv.sales.scn.adjust.volumeDown': 'Drop in sales volume',
  // -------------------------------------------------------------- New sale
  'sale.doc.invoice': 'New invoice',
  'sale.doc.quote': 'New quote',
  'sale.doc.orderConfirmation': 'New order confirmation',
  'sale.doc.creditNote': 'New credit note',
  'sale.doc.other': 'Other sale',
  'sale.howToCreate': 'How do you want to create {document}?',
  'sale.docIndefinite.invoice': 'an invoice',
  'sale.docIndefinite.quote': 'a quote',
  'sale.docIndefinite.orderConfirmation': 'an order confirmation',
  'sale.docIndefinite.creditNote': 'a credit note',
  'sale.docIndefinite.other': 'another sale',
  'sale.credit.title': 'Crediting',
  'sale.credit.help': 'A credit note reverses a sale. Enter positive amounts just like on an invoice — Plumme flips the sign when posting, so sales revenue and output VAT are reduced and the receivable is credited.',
  'sale.credit.reason': 'Reason for crediting',
  'sale.credit.reasonHint': 'Required. The record must show what actually happened, not just the amount.',
  'sale.credit.reasonPh': 'Returned goods, price reduction, incorrect invoice ...',
  'sale.credit.link': 'Link to invoice',
  'sale.credit.linkHint': 'Optional. If linked, the invoice number is added automatically and the credit note is offset against that invoice’s outstanding amount.',
  'sale.credit.linkNone': 'No link – open customer credit',
  'sale.credit.linkSearchPh': 'Search by invoice number, customer or amount ...',
  'sale.credit.linkNoMatches': 'No invoices match your search',
  'sale.credit.linkShowMore': 'Show more invoices',
  'sale.credit.invoiceOption': 'Invoice {number} · {customer}',
  'sale.credit.invoiceOptionMeta': '{date} · {amount}',
  'sale.credit.linkLocked': 'Selected from the invoice',
  'sale.credit.noNumber': 'No number',
  'sale.credit.reference': 'Applies to (original sale)',
  'sale.credit.referenceHint': 'Required without an invoice link. Enter the invoice number, agreement, period or the system the sale was in.',
  'sale.credit.referencePh': 'E.g. invoice 1042 or "agreement 2025-04"',
  'sale.credit.linkedTo': 'Credits invoice {document}',
  'sale.credit.offsetBadge': 'Offset automatically',
  'sale.credit.freeHint': 'Without a link the amount stays as customer credit. You can offset it against an invoice or refund it from the invoice list.',
  'sale.credit.date': 'Credit note date',
  'sale.credit.numberLabel': 'Credit note no.:',
  'sale.credit.amount': 'Credit amount',
  'sale.credit.previewNote': 'The amount has been credited. It is offset against outstanding invoices or refunded.',
  'sale.credit.previewReason': 'Reason:',
  'sale.credit.previewReference': 'Applies to:',
  'sale.credit.set': 'Set details',
  'sale.credit.edit': 'Edit',
  'sale.credit.missing': 'A reason and reference to the original sale are required before the credit note can be created.',
  'sale.credit.noReference': 'No reference given',
  'sale.credit.freeBadge': 'Open customer credit',
  'sale.credit.needReason': 'Enter the reason for crediting first',
  'sale.credit.needReference': 'Link an invoice or identify the original sale this credit note applies to',
  'sale.credit.needDetails': 'Enter a reason and link an invoice or identify the original sale first',
  'sale.credit.create': 'Create credit note',
  'sale.det.period': 'Period',
  'sale.det.subscriptionFrom': 'Subscription from',
  'sale.det.subscriptionTo': 'Subscription to',
  'sale.det.rentFrom': 'Rental from',
  'sale.det.rentTo': 'Rental to',
  'sale.lines.descShortPh': 'E.g. consulting hour or subscription',
  'sale.from': 'From',
  'sale.to': 'To',
  'sale.use': 'Use',
  'sale.swap': 'Swap',
  'sale.show': 'Show',
  'sale.edit': 'Edit',
  'sale.download': 'Download',
  'sale.send': 'Send',
  'sale.add': 'Add',
  'sale.save': 'Save',
  'sale.saveChanges': 'Save changes',
  'sale.thisSale': 'this sale',
  'sale.step.kunde': 'Customer',
  'sale.step.bilag': 'Receipt',
  'sale.step.detaljer': 'Details',
  'sale.step.linjer': 'Lines',
  'sale.step.forhandsvisning': 'Preview',
  'sale.title': 'Sale / Invoice / Quote',
  'sale.titleHelp': 'Register a sale, create an invoice, quote or order confirmation',
  'sale.docTypeHelpTitle': 'Document type',
  'sale.docTypeHelp': 'Choose the kind of sales document you are creating. An invoice is a payment demand to the customer. A quote is a non-binding price offer. An order confirmation confirms an agreed order. Other sale is for sales outside the system, where you upload a receipt as documentation.',
  'sale.stepsHelpTitle': 'The steps in a sale',
  'sale.stepsHelp': 'A sale has four steps: Customer, Details, Lines and Preview (for Other sale: Receipt, Details, Lines and Preview). Tap a step to jump there. A step is marked if something is missing before the document can be created.',
  'sale.viewHelpTitle': 'Switch view',
  'sale.viewHelpToOnePage': 'Switches from the step-by-step flow to a single page where all fields are shown at once, next to a live preview. Faster once you know the form.',
  'sale.viewHelpToSteps': 'Switches from the single page to a calm step-by-step flow where you fill in one thing at a time — customer, details, lines and preview. Good when you want guidance along the way.',
  'sale.toOnePage': 'Switch to all on one page',
  'sale.toSteps': 'Switch to step-by-step',
  'sale.stepByStep': 'Step by step',
  'sale.previewHelpTitle': 'Preview',
  'sale.previewHelp': 'This is how the finished document looks to the customer — with sender, customer details, lines and total. It updates as you fill in, so you can check everything before creating or sending.',
  'sale.previewToggleHelp': 'Shows or hides the live preview next to the form. Hide it if you want more room for the fields.',
  'sale.previewHide': 'Hide preview',
  'sale.previewShow': 'Show preview',
  'sale.previewHeading': 'How the document looks',
  'sale.backToVouchers': 'Back to transactions',
  'sale.resetTitle': 'Clear the form and start over',
  'sale.reset': 'Clear', 'sale.resetDone': 'The form has been cleared',
  'sale.back': 'Back',
  'sale.next': 'Next',
  'sale.draftSaved': 'Draft saved',
  'sale.draftSavedHelp': 'The draft is in the invoice list exactly as it stands. Change something and you can save again — it updates the same draft.',
  'sale.saveDraft': 'Save draft',
  'sale.saveDraftHelpTitle': 'Save draft',
  'sale.saveDraftHelp': 'Saves the sale as a draft in the invoice list without sending or creating it. You can pick up where you left off later.',
  'sale.saveDraftHelpLong': 'Saves the sale as a draft in the invoice list without sending or creating it. You can safely leave the page and continue where you left off.',
  'sale.saveDraftHelpShort': 'Saves the sale as a draft in the invoice list without sending or creating it. You can safely leave the page and continue later.',
  'sale.drafts': 'Drafts',
  'sale.draftsTitle': 'Sales you have started but not created yet',
  'sale.noDrafts': 'No drafts',
  'sale.searchDrafts': 'Search drafts...',
  'sale.deleteDraft': 'Delete draft',
  'sale.deleteDraftTitle': 'Delete draft?',
  'sale.deleteDraftBody': 'Are you sure you want to delete the draft for {customer}? This cannot be undone.',


  'sale.det.help': 'Dates, references and a comment for the document. The invoice date and due date control when the claim applies and falls due. "Our reference" is the person handling it at your end, "Your reference" is the customer project or contact. For invoices you can also turn on recurring, so it is sent automatically each period.',
  'sale.det.date': 'Date',
  'sale.det.due': 'Due',
  'sale.det.ourRef': 'Our reference',
  'sale.det.ourRefPh': 'E.g. the person handling it here',
  'sale.det.theirRef': 'Your reference',
  'sale.det.theirRefPh': 'Your reference / project',
  'sale.det.payTo': 'Pay to',
  'sale.det.payToHelp': 'The bank account the customer should pay the invoice to. The list shows your saved bank accounts — the invoice account from settings is preselected, and you can add a new account right here.',
  'sale.det.payToDefault': 'Invoice account',
  'sale.det.payToEmpty': 'No bank account saved',
  'sale.det.payToAdd': '+ Add bank account ...',
  'sale.det.comment': 'Comment',
  'sale.det.commentPh': 'Optional comment shown on the document',
  'sale.det.savedComments': 'Saved comments',
  'sale.det.saveComment': 'Save comment',
  'sale.det.useComment': 'Use comment',
  'sale.det.noSavedComments': 'No saved comments yet.',
  'sale.det.deliveryFrom': 'Delivery/performance period - From',
  'sale.det.deliveryTo': 'Delivery/performance period - To',
  'sale.det.repeating': 'Recurring',
  'sale.det.repeatingHelpTitle': 'Recurring invoice',
  'sale.det.repeatingHelp': 'Turn on to have the invoice sent automatically at regular intervals — for example monthly for a subscription. You choose the interval and due date, and Plumme creates and sends a new invoice each period without you doing anything.',
  'sale.det.sentEvery': 'Sent every',
  'sale.period.week': 'Week',
  'sale.period.month': 'Month',
  'sale.period.quarter': 'Quarter',
  'sale.period.year': 'Yearly',
  'sale.det.sameDay': 'Same day',

  'sale.lines.help': 'The goods and services on the sale. Each line has a quantity, price, VAT rate and any discount, and the line total is calculated automatically. Pick a saved product or write free text, and drag the handle on the left to reorder.',
  'sale.lines.add': 'Add line',
  'sale.lines.product': 'Product',
  'sale.lines.productPh': 'Search or write a new product...',
  'sale.lines.noProductMatch': 'No saved products match',
  'sale.lines.editProduct': 'Edit product',
  'sale.lines.productName': 'Product name',
  'sale.lines.description': 'Description',
  'sale.lines.descriptionPh': 'Optional description of the product/line',
  'sale.lines.qty': 'Quantity',
  'sale.lines.vat': 'VAT',
  'sale.lines.discount': 'Discount',
  'sale.lines.netSum': 'Line total excl. VAT',
  'sale.lines.toggleVat': 'Switch between excl. and incl. VAT',
  'sale.lines.more': 'More',
  'sale.lines.less': 'Less',
  'sale.lines.searchAccount': 'Search account...',
  'sale.lines.noAccountMatch': 'No accounts match the search.',
  'sale.lines.pickAccount': 'Choose account',
  'sale.lines.searchProductPh': 'Search by name or description...',

  'sale.sum.help': 'The total for the whole sale: the sum excluding VAT, plus VAT, equals the amount the customer pays. The figures update automatically as you change the lines.',

  'sale.att.title': 'Attachments',
  'sale.att.upload': 'Upload attachment',
  'sale.att.drop': 'Drag files here',
  'sale.att.dropHint': 'Images or PDF, or paste',
  'sale.att.pickFile': 'Choose file',
  'sale.att.dropToAdd': 'Drop the attachment to add it',
  'sale.att.dragTip': 'Tip: you can also drag files straight onto the page.',
  'sale.att.forgot': 'Forgotten a receipt? Drop it here',
  'sale.att.fromInbox': 'Get from Inbox',
  'sale.att.uploadInstead': 'Upload a receipt instead',
  'sale.att.view': 'View the receipt',
  'sale.att.openPreview': 'Open in preview',

  'sale.send.title': 'Sending document',
  'sale.send.to': 'Send to',
  'sale.send.replyTo': 'Reply to',
  'sale.send.asPdf': 'Send as PDF attachment',
  'sale.send.asLink': 'Send as a link',
  'sale.send.pdfHint': 'The customer gets the document directly in the email.',
  'sale.send.linkHint': 'Gives read status when the customer opens the document.',
  'sale.send.how': 'How should the document be sent?',
  'sale.send.newRecipient': 'New email address …',
  'sale.send.saveContact': 'Save as a contact on {customer}',
  'sale.send.thisCustomer': 'the customer',
  'sale.send.contactName': 'Name',
  'sale.send.contactNamePh': 'Jane Doe',
  'sale.send.contactRole': 'Role',
  'sale.send.contactRolePh': 'Accounting',
  'sale.send.contactSaveFailed': 'The document was sent, but the contact could not be saved.',
  'sale.send.emailPh': 'name@example.com',
  'sale.send.viewDocument': 'View the document',

  'sale.preview.sender': 'Sender:',
  'sale.preview.invoiceNo': 'Invoice no.:',
  'sale.preview.invoiceDate': 'Invoice date:',
  'sale.preview.dueDate': 'Due date:',
  'sale.preview.ourRef': 'Our reference:',
  'sale.preview.theirRef': 'Your reference:',
  'sale.preview.comment': 'Comment:',
  'sale.preview.accountNo': 'Account no.:',
  'sale.preview.toPay': 'To pay:',
  'sale.preview.net': 'Net',
  'sale.preview.vat': 'VAT',
  'sale.preview.paid': 'Paid',
  'sale.preview.toPayShort': 'To pay',
  'sale.preview.receipt': 'Receipt',
  'sale.preview.paymentHint': 'Please include the invoice number in your payment',
  'sale.preview.currencyNote': 'All amounts are stated in {currency}',

  // ---------------------------------------------------------- New sale (i18n cleanup)
  'sale.lines.fromDraftDescr': 'Transferred from draft',
  'sale.att.maxSize': 'Attachments can be at most {max}.', 'sale.att.addedOne': '1 attachment added', 'sale.att.addedMany': '{count} attachments added',
  'sale.comment.deleted': 'Comment deleted',
  'sale.comment.deleteFailed': 'Could not delete the comment.',
  'sale.comment.writeFirst': 'Write a comment first',
  'sale.comment.updated': 'Comment updated',
  'sale.comment.saveFailed': 'Could not save the comment.',
  'sale.comment.alreadySaved': 'The comment is already saved',
  'sale.comment.saved': 'Comment saved', 'sale.comment.backendUnavailable': 'Comments are not connected to the backend.',
  'sale.det.offerDate': 'Quote date',
  'sale.det.orderDate': 'Order date',
  'sale.det.saleDate': 'Sale date',
  'sale.det.invoiceDateLabel': 'Invoice date',
  'sale.det.validUntil': 'Valid until',
  'sale.det.dueDateLabel': 'Due date',

  // ---------------------------------------------------- New sale (second half)
  'sale.textLine.titleUpdate': 'Update text line',
  'sale.textLine.titleNewHeading': 'New heading',
  'sale.textLine.titleNewText': 'New text line',
  'sale.textLine.update': 'Update',
  'sale.textLine.typeLabel': 'Type',
  'sale.textLine.typeText': 'Text line',
  'sale.textLine.typeHeading': 'Heading',
  'sale.textLine.nameLabel': 'Name',
  'sale.textLine.namePhHeading': 'E.g. Work',
  'sale.textLine.namePhText': 'E.g. Product X',
  'sale.textLine.textLabel': 'Text',
  'sale.textLine.textPh': 'Optional text shown under the line',
  'sale.textLine.styleFor': 'Style for {target}',
  'sale.textLine.boldShort': 'B',
  'sale.textLine.italicShort': 'I',
  'sale.textLine.useDivider': 'Use divider line',
  'sale.textLine.dividerHint': 'Show a line under the text in the document.',
  'sale.textLine.searchPhHeading': 'Search or write a heading...',
  'sale.textLine.searchPhText': 'Search or write a text line...',
  'sale.textLine.noMatch': 'No saved text lines match',
  'sale.textLine.addAsHeading': 'Add "{value}" as a new heading',
  'sale.textLine.addAsText': 'Add "{value}" as a new text line', 'sale.textLine.headingSaved': 'Heading saved', 'sale.textLine.textSaved': 'Text line saved', 'sale.textLine.headingAdded': 'Heading added', 'sale.textLine.textAdded': 'Text line added', 'sale.textLine.saveFailed': 'Could not save the text line.',

  'sale.det.durationMonth1': '1 month', 'sale.det.durationMonth3': '3 months', 'sale.det.durationMonth6': '6 months',
  'sale.det.durationMonth12': '12 months',

  'sale.lines.typeProduct': 'Product line',
  'sale.lines.typeSpacer': 'Spacer',
  'sale.lines.noText': 'No text',
  'sale.lines.qtyUnit': '{qty} pcs',

  'sale.preview.receiptNoLabel': 'Receipt no.:',
  'sale.preview.quoteNoLabel': 'Quote no.:',
  'sale.preview.orderNoLabel': 'Order no.:',
  'sale.preview.backToOther': 'Back to Other sale',
  'sale.preview.backToInvoice': 'Back to invoice',
  'sale.preview.vatMoms': 'VAT',
  'sale.preview.continuesNextPage': 'Continues on next page',

  'sale.att.labelWithName': 'Attachment · {name}',
  'sale.att.dropHere': 'Drop the attachment here',
  'sale.att.otherSaleHint': 'Other sale is for general sales outside the system - upload an image or PDF as documentation.',
  'sale.att.previewHint': 'To preview, tap one of your attachments or View receipt.',
  'sale.att.viewReceipt': 'View receipt',
  'sale.att.createReceipt': 'Create receipt',

  'sale.mode.subtitle': 'Choose a calm step-by-step flow, or keep all fields together on one page.',
  'sale.mode.stepsDesc': 'Customer, details, lines and preview - one thing at a time. Good for beginners.',
  'sale.mode.onePageDesc': 'The whole invoice together with a live preview. Fast once you know it.',

  'sale.draft.noCustomer': 'No customer',
  'sale.draft.noMatchesTitle': 'No matches',
  'sale.draft.noMatchesText': 'No drafts match the search.',
  'sale.draft.emptyText': 'Sales you have started are saved here when you press Save draft.',
  'sale.draft.colSale': 'Sale',
  'sale.draft.noNumber': 'No number',
  'sale.draft.colDate': 'Date',
  'sale.draft.colAmount': 'Amount',
  'sale.draft.deleteFailed': 'Could not delete the draft.',
  'sale.draft.saveFailed': 'Could not save the draft.', 'sale.draft.deleteUnavailable': 'Draft deletion is not connected to the backend.', 'sale.draft.onlyDraftsDelete': 'Only drafts can be deleted here', 'sale.draft.deleted': 'Draft deleted', 'sale.draft.saveUnavailable': 'Draft saving is not connected to the backend.', 'sale.draft.savedToList': 'The draft has been saved to the invoice list',

  'sale.create.invoice': 'Create invoice',
  'sale.create.quote': 'Create quote',
  'sale.create.order': 'Create order confirmation',
  'sale.create.other': 'Register sale',
  'sale.create.needMatchingPartials': 'The sum of the instalments must match the sale total first',
  'sale.create.needLineOrAttachment': 'Add a line or an attachment first',
  'sale.create.needCustomerAndProduct': 'Choose a customer and add at least one product first',
  'sale.create.needCustomer': 'Choose a customer first',
  'sale.create.needProduct': 'Add at least one product first',
  'sale.create.receiptSendingBackground': 'The receipt is being sent in the background',
  'sale.create.receiptSentEmail': 'The receipt was sent by email.',
  'sale.create.recurringSaveFailed': 'The invoice was created, but the recurring agreement could not be saved.',
  'sale.create.createFailed': 'Could not create the sale.',
  'sale.create.createdTitle': '{doc} {num} has been created.',
  'sale.create.saleCreatedBody': 'The sale has been posted. You can save the receipt, send documentation to the customer or close.',
  'sale.create.docCreatedBody': 'You can save {def} as a PDF or send {pron} on by email.',
  'sale.create.pdfReceiptLabel': 'PDF/Receipt',
  'sale.create.pdfLabel': 'PDF',

  'sale.send.unavailableSale': 'Sending is not available for this sale.',
  'sale.send.unavailableDocument': 'Sending is not available for this document.',
  'sale.send.failed': 'The sending failed.',
  'sale.send.customerFallback': 'Customer',
  'sale.send.defaultContactRole': 'Default contact',
  'sale.send.contactFallback': 'Contact person',
  'sale.send.recipientFallback': 'Recipient',
  'sale.send.receiptTitle': 'Send receipt',
  'sale.send.howToSend': 'How do you want to send {doc}?',
  'sale.send.receiptEmailHint': 'Enter the email address the receipt should be sent to.',
  'sale.send.chooseDeliveryHint': 'Choose whether the customer gets a PDF in the email, or a link Postplumma can track.',
  'sale.send.allCustomersInList': 'All customers in the list ({count})',
  'sale.send.needEmailFirst': 'Enter an email on the customer or a contact person before sending.',
  'sale.send.stepDraftPrep': 'Preparing draft',
  'sale.send.stepArriving': 'Postplumma is arriving',
  'sale.send.stepSuccess': 'Success! Postplumma is on its way.',
  'sale.send.receiptReadyNoEmail': 'The receipt is ready, but no email was sent.',
  'sale.send.sendingInBackground': '{doc} is being sent in the background',
  'sale.send.sentAsLinkShort': '{doc} was sent as a link.',
  'sale.send.sentAsLinkTracked': '{doc} was sent as a link. You can follow the read status in the invoice list.',
  'sale.send.sentAsEmail': '{doc} was sent by email.',
  'sale.send.readyNoEmail': '{doc} is ready, but no email was sent.',
  'sale.send.sentToRecipients': 'Sent to {count} recipients.',
  'sale.send.notProvided': 'Not provided',
  'sale.send.spamTip': 'Tip: If the customer can\'t find the email, ask them to check spam/junk.',

  'sale.inboxPicker.tabInbox': 'Inbox ({count})',
  'sale.inboxPicker.tabDocumentation': 'Documentation ({count})',
  'sale.inboxPicker.searchDocumentation': 'Search documentation',
  'sale.inboxPicker.searchInbox': 'Search the inbox',
  'sale.inboxPicker.selectTip': 'Tip: Hold Shift to select several in a row, or Ctrl/Cmd to select individually.',
  'sale.inboxPicker.emptyDocumentation': 'No documents match the search.',
  'sale.inboxPicker.emptyInbox': 'No receipts in the inbox match the search.',
  'sale.inboxPicker.fallbackReceipt': 'Receipt',
  'sale.inboxPicker.fallbackDocument': 'Document',
  'sale.inboxPicker.fallbackDocumentation': 'Documentation',
  'sale.lines.subscriptionPeriod': 'Subscription - {{period}}', 'sale.lines.months12': '12 mo', 'sale.lines.month1': '1 mo', 'sale.lines.rentalPrice': 'Rental - {{price}}',
  'sale.lines.addAsNewProduct': 'Add "{{value}}" as a new product',
  'sale.lines.useDivider': 'Use divider line', 'sale.lines.dividerHint': 'Shows a line below this row in the document.',
  'sale.preview.colDescription': 'Description', 'sale.preview.colQty': 'Qty', 'sale.preview.colPrice': 'Price', 'sale.preview.colDiscount': 'Discount', 'sale.preview.colSum': 'Total',
  'sale.doc.invoiceName': 'Invoice', 'sale.doc.quoteName': 'Quote', 'sale.doc.orderConfirmationName': 'Order confirmation', 'sale.doc.creditNoteName': 'Credit note',
  'sale.draft.colType': 'Type',
  'sale.period.every14days': 'Every 14 days', 'sale.det.dueDays': '{{count}} days',
  'sale.lines.priceExVat': 'Price excl. VAT', 'sale.lines.priceIncVat': 'Price incl. VAT', 'sale.lines.lineNumber': 'Line {{n}}', 'sale.lines.pickProduct': 'Choose product', 'sale.lines.freeText': 'Free text', 'sale.lines.spacerHint': 'An empty line shows as a blank space in the document.',
  'sale.lines.chooseLineType': 'Choose line type',
  'agreements.notSent': 'Not sent', 'agreements.error.missingCustomerEmail': 'The customer has no email address. Add an email to the customer and the invoice is sent on the next run.', 'agreements.error.missingCustomer': 'The customer no longer exists or is archived. Choose an active customer for the agreement.', 'agreements.warning.missingCustomerEmail': 'Customer has no email address', 'agreements.warning.missingCustomerEmailHelp': 'Automatic sending needs an email address. Add it to the customer before the next invoice date, or the invoice will not be sent.',
});
